import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import ProductItem from './product-item';
import ProductItemCol from './product-col-item';
import { kv } from "../../mixin/kv";
import { purchaseQuantityProcessing } from '@/utils';
export default {
  mixins: [kv],
  components: {
    ProductItem: ProductItem,
    ProductItemCol: ProductItemCol
  },
  data: function data() {
    return {
      list: [],
      isColList: false //是否列表模式
    };
  },
  props: {
    id: {
      type: String
    },
    productCode: {
      type: String
    }
  },
  watch: {
    "id": function id(newV, oldV) {
      this.kv_visit(13);
      this.getList();
    }
  },
  created: function created() {
    this.kv_visit(13);
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, url, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = {
                page: 1,
                pageSize: 500,
                productAliasCode: _this.id,
                productCode: _this.productCode
              };
              url = '/pjyy-deepexi-product-center/api/v4/product/PcProductCommon/similar';
              _context.next = 4;
              return _this.$getHttpClient().post(url, params);
            case 4:
              result = _context.sent;
              if (result.data.code == '200') {
                _this.list = purchaseQuantityProcessing(result.data.data.list || []);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //大图列表转换
    swich: function swich(flag) {
      this.isColList = flag;
    }
  }
};